'use client';

import { AppIntroductionActionsheet } from '~/app/_components/app-introduction-actionsheet';
import { useLocalHooks } from './use-local-hooks';

type Params = {
  title?: string | JSX.Element;
  description?: string | JSX.Element;
  deepLinkValue: string;
};

export const AppIntroductionActionsheetContainer = ({
  title,
  description,
  deepLinkValue,
}: Params) => {
  const { openInAppClick, actionsheetModalDisclosure } = useLocalHooks({
    deepLinkValue,
  });

  return (
    <AppIntroductionActionsheet
      title={title}
      description={description}
      isOpen={actionsheetModalDisclosure.isOpen}
      close={actionsheetModalDisclosure.onClose}
      onOpenAppClick={openInAppClick}
    />
  );
};
